"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataLayerProperties = void 0;
var constants_1 = require("../constants/constants");
var stringFormatters_1 = require("./stringFormatters");
var dateFormatters_1 = require("./dateFormatters");
/**
 *
 * @param Object Takes object with the following options:
 * @param accessType(optional) - AccessType - Pro | Pub
 * @param author(optional) - String - can include multiple, comma separated
 * @param dateModifiedUtc(optional) - String
 * @param datePublishedUtc(optional) - String
 * @param editor(optional) - String - can include multiple, comma separated
 * @param isAdBlock(optional) - Boolean
 * @param isLocked(optional) - Boolean
 * @param paywallType(optional) - PaywallType - None | Partial
 * @param section(optional) - String - Other | Analysts | Marketing Pages | Search | Topic Homepage | River | Forecast | Chart | Report | Article | Insights
 * @param keywords(optional) - String -  can include multiple, comma separated. I.e. keywords in Content Builder
 * @param geographies(optional) - String can include multiple, comma separated. I.e. "United States", "United Kingdom"
 * @param topics(optional) - String -  can include multiple, comma separated. I.e. 'More' in Marketing Page's Posts
 * @param unifiedAssetId(optional) - String
 * @param connectedUnifiedAssetIds(optional) - String - can include multiple, comma separated unifiedAssetIds, i.e. Premium Forecast typically includes/compares multiple "classic" forecasts
 * @param vertical(optional) - String -  I.e. categories on insights pages
 * @param wordCount(optional) - Number, undefined if empty. Use getWordCount to help.
 * @param userSubscriptionTier(optional) - UserSubscriptionTier - pro | pro-plus | pro-with-ikpi | freemium | anonymous.
 * @output pushes formatted options into window.dataLayer
 * NOTE: If you make changes to add the wrapInPipesAndCapitalize function to other properties, remember to update the convertPipeToCommaInDataLayer function in BOTH: `Analytics.Harvester` && `eMarketer.Analytics` repos, accordingly.
 */
var getDataLayerProperties = function (_a) {
    var accessType = _a.accessType, author = _a.author, dateModifiedUtc = _a.dateModifiedUtc, datePublishedUtc = _a.datePublishedUtc, editor = _a.editor, isAdBlock = _a.isAdBlock, isLocked = _a.isLocked, paywallType = _a.paywallType, section = _a.section, keywords = _a.keywords, geographies = _a.geographies, topics = _a.topics, unifiedAssetId = _a.unifiedAssetId, connectedUnifiedAssetIds = _a.connectedUnifiedAssetIds, vertical = _a.vertical, wordCount = _a.wordCount, userSubscriptionTier = _a.userSubscriptionTier;
    return {
        event: constants_1.DATA_LAYER_EVENT_PAGE_VIEW,
        accessType: accessType ? (0, stringFormatters_1.cleanAndLowercase)(accessType) : '',
        author: author ? (0, stringFormatters_1.wrapInPipesAndCapitalize)(author) : '',
        dateModifiedUtc: dateModifiedUtc ? (0, dateFormatters_1.formatDateToUTC)(dateModifiedUtc) : '',
        datePublishedUtc: datePublishedUtc ? (0, dateFormatters_1.formatDateToUTC)(datePublishedUtc) : '',
        editor: editor ? (0, stringFormatters_1.cleanAndCapitalize)(editor) : '',
        isAdBlock: isAdBlock === true ? true : isAdBlock === false ? false : '',
        isLocked: isLocked === true ? true : isLocked === false ? false : '',
        paywallType: paywallType ? paywallType : '',
        section: section ? (0, stringFormatters_1.cleanAndCapitalize)(section) : '',
        keywords: keywords ? (0, stringFormatters_1.wrapInPipesAndCapitalize)(keywords) : '',
        geographies: geographies ? (0, stringFormatters_1.wrapInPipesAndCapitalize)(geographies) : '',
        topics: topics ? (0, stringFormatters_1.wrapInPipesAndCapitalize)(topics) : '',
        unifiedAssetId: unifiedAssetId ? (0, stringFormatters_1.cleanAndLowercase)(unifiedAssetId) : '',
        connectedUnifiedAssetIds: connectedUnifiedAssetIds ? (0, stringFormatters_1.wrapInPipesAndLowercase)(connectedUnifiedAssetIds) : '',
        vertical: vertical ? (0, stringFormatters_1.wrapInPipesAndCapitalize)(vertical) : '',
        wordCount: wordCount,
        userSubscriptionTier: userSubscriptionTier || 'anonymous',
    };
};
exports.getDataLayerProperties = getDataLayerProperties;
//# sourceMappingURL=dataLayerConstructor.js.map